import React , { useState, useEffect } from "react";
import Navbar from "./navbar";


const Orderhistory = () =>{
   
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1250);
  useEffect(() => {
    window.addEventListener("resize", () => {
        const ismobile = window.innerWidth < 1250;
        if (ismobile !== isMobile) setIsMobile(ismobile);
    }, false);
  }, [isMobile]);   

  return(
      <>
          <section className="order-details shopping-cart-page">
              {/* <div className="col-12 order-header">
              <Navbar />
              </div> */}
              {/* <div className="col-12 order-body"> */}
                  {/******* order-details-section **********/}
                  <div className="shopping-cart-body card card-no-bg-border">
                      <div className="card-body">
                        <h1 className="main-body-title">
                            <span>
                                <i class="fas fa-history title-icon" aria-hidden="true"></i>
                                Order History
                            </span>
                        </h1>
                        <h2 className="thanks-text text-center">Orders in the last 6 months</h2>
                        <div className="history-group clearfix">
                            <div className="row card history-card mb-2">
                                <div className="col-3 col-sm-2 col-lg-1 col-xl-1 col-xxl-1 p-0">
                                    <div className="qr-code-wrapper">
                                        <img src="./../images/qrcodeimg.png" className="img-thumbnail qr-img border-0" alt="QR-Code"></img>
                                    </div>
                                </div>
                                <div className="col-9 col-sm-10 col-lg-11 col-xl-11 col-xxl-11">
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order number">Order number: </span>
                                        <span className="order-details-2" title="12345678901111">12345678901111</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order Date">Order Date: </span>
                                        <span className="order-details-2" title="11/15/2021">11/15/2021</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Delivery Date">Delivery Date: </span>
                                        <span className="order-details-2" title="11/15/2021">11/15/2021</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Status">Status: </span>
                                        <span className="order-details-2" title="Submitted">Submitted</span>
                                    </p>
                                </div>
                            </div>
                            <div className="row card history-card mb-2">
                                <div className="col-3 col-sm-2 col-lg-1 col-xl-1 col-xxl-1 p-0">
                                    <div className="qr-code-wrapper">
                                        <img src="./../images/qrcodeimg.png" className="img-thumbnail qr-img border-0" alt="QR-Code"></img>
                                    </div>
                                </div>
                                <div className="col-9 col-sm-10 col-lg-11 col-xl-11 col-xxl-11">
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order number">Order number: </span>
                                        <span className="order-details-2" title="12345678901111">12345678901111</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Order Date">Order Date: </span>
                                        <span className="order-details-2" title="11/15/2021">11/15/2021</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Delivery Date">Delivery Date: </span>
                                        <span className="order-details-2" title="11/15/2021">11/15/2021</span>
                                    </p>
                                    <p className="Order-details-wrapper">
                                        <span className="order-details-1" title="Status">Status: </span>
                                        <span className="order-details-2" title="Submitted">Submitted</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>
                  {/******** order-details-section *********/}
              {/* </div> */}
          </section>
      </>
  )
  }
  
  export default Orderhistory;